import { useState } from "react";
import { ExternalLink, Globe, RefreshCw, X } from "lucide-react";
import { useLanguage } from "../i18n";
import "./finance-websites.css";

// The official portal generates fresh login redirect parameters.
const TAX_PORTAL_URL = "https://etax.guangdong.chinatax.gov.cn:8443/";

export function FinanceWebsites() {
  const { t } = useLanguage();
  const [opened, setOpened] = useState(false);
  const [revision, setRevision] = useState(0);
  return <section className="finance-websites" aria-label={t("财务常用网站", "Finance websites")}>
    <div className="finance-website-card">
      <Globe aria-hidden="true"/>
      <div><h3>{t("税务局", "Tax bureau")}</h3><p>{t("广东省电子税务局", "Guangdong Electronic Tax Service")}</p><small>etax.guangdong.chinatax.gov.cn</small></div>
      <div className="finance-website-actions">
        <button type="button" className="button primary" onClick={()=>setOpened(true)}>{t("OA 内打开", "Open in OA")}</button>
        <a className="button secondary" href={TAX_PORTAL_URL} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer"><ExternalLink aria-hidden="true"/>{t("新窗口打开", "Open in new window")}</a>
      </div>
    </div>
    {!opened&&<p className="finance-website-help">{t("点击「OA 内打开」访问税务网站。请在税务局官方登录页输入账号并完成验证。", "Open the tax website inside OA, then sign in and complete verification on the official website.")}</p>}
    {opened&&<div className="finance-website-browser">
      <div className="finance-website-toolbar">
        <strong>{t("税务局", "Tax bureau")}</strong><span title={TAX_PORTAL_URL}>etax.guangdong.chinatax.gov.cn</span>
        <div className="finance-website-actions">
          <button type="button" className="button secondary" onClick={()=>setRevision(value=>value+1)}><RefreshCw aria-hidden="true"/>{t("重新打开", "Reopen")}</button>
          <a className="button secondary" href={TAX_PORTAL_URL} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer"><ExternalLink aria-hidden="true"/>{t("新窗口打开", "New window")}</a>
          <button type="button" className="button secondary" onClick={()=>setOpened(false)}><X aria-hidden="true"/>{t("关闭", "Close")}</button>
        </div>
      </div>
      <p className="finance-website-help">{t("若页面空白、提示拒绝连接，或登录验证无法完成，请使用「新窗口打开」。账号密码请直接在税务网站填写。", "If the page is blank, refuses to connect, or login verification does not work, use New window. Enter your credentials directly on the tax website.")}</p>
      <iframe key={revision} title={t("广东省电子税务局", "Guangdong Electronic Tax Service")} src={TAX_PORTAL_URL} referrerPolicy="no-referrer"/>
    </div>}
  </section>;
}
